import { TableContainer } from "@mui/material";
import { Table } from "antd";
import React, { useState } from "react";
import ExportToExcel from "~/components/ExportToExcel";

const PlantationData = (data) => {
  console.log(data, "responseData");
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 25,
    },
  });

  const columns = [
    {
      title: "Plant Name",
      dataIndex: "Plant_Local_Name",
      responsive: ["lg", "md", "xl", "sm"],
    },
    {
      title: "Plotting name",
      dataIndex: "Plot_Name",
      responsive: ["lg", "md", "xl", "sm"],
    },
    {
      title: "Plantation type",
      dataIndex: "Plantation_Type",
      responsive: ["lg", "md", "xl", "sm"],
    },
    {
      title: "Number of plant",
      dataIndex: "Total_Plant_Count",
      key: "Total_Plant_Count",
      responsive: ["lg", "md", "xl", "sm"],
    },
    {
      title: "Monitoring numbers",
      dataIndex: "Total_Plant_Monitoring_Count",
      key: "Total_Plant_Monitoring_Count",
      responsive: ["lg", "md", "xl", "sm"],
    },
    {
      title: "Aspect",
      dataIndex: "Aspect",
      key: "Aspect",
      responsive: ["lg", "md", "xl", "sm"],
    },
    {
      title: "Soil texture",
      dataIndex: "Soil_Texture",
      key: "Soil_Texture",
      responsive: ["lg", "md", "xl", "sm"],
    },
  ];

  return (
    <>
      <ExportToExcel data={data.reportData} columns={columns} fileName="Plantation Data.csv" />
      <TableContainer sx={{ boxShadow: "none" }}>
        <Table
          scroll={{
            x: 2000,
            y: 1000,
          }}
          columns={columns}
          dataSource={data.reportData}
          pagination={{
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
          }}
        />
      </TableContainer>
    </>
  );
};

export default PlantationData;
